import { CTBProgram } from "../../utils/api/endpoints/programs/parsePrograms";
import Pill from "../pills/Pill";

const ProgramTargets = ({ program }: { program: CTBProgram }) => (
  <div className="flex flex-col gap-3">
    {program.targets.map((target, index) => {
      const isDeleted = !!(target as any).deleted_at;
      return (
        <Pill
          key={index}
          className={`px-2 py-1 text-sm font-light !text-black ${isDeleted ? "opacity-60 grayscale bg-gray-100 border border-gray-200" : "bg-ctb-grey-200"
            }`}
        >
          <div className="flex items-center gap-1.5">
            <span>{target.targetName}</span>
            {isDeleted && (
              <span className="px-1 py-0.5 rounded text-[8px] font-bold uppercase bg-red-500 text-white leading-none">
                Deleted
              </span>
            )}
          </div>
        </Pill>
      );
    })}
  </div>
);

export default ProgramTargets;
